export function pluralize(word, count){
  return `${word}${count != 1 ? 's' : ''}`
}

window.pluralize = pluralize;
